<div class="grid align-center padding-top-large padding-horizontal-medium padding-bottom-medium margin-bottom-xlarge document-template">
  <div class="cell cell-large-col-span-6">
    <h1>Important Documents</h1>
    <p class="cell cell-large-col-span-12 margin-bottom-medium">It's important to know what you are covered for. This page lists all the important documents related to your policy, including our terms and conditions and privacy policy.</p>
  </div>

  <div *ngFor="let category of categories; index as i;" class="cell cell-large-col-span-12 padding-top-xmedium category-wrapper">
    <div class="grid">
      <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-top-medium padding-bottom-medium category-header">
        <h2 class="h1-page-heading">{{ category.title }}</h2>
        <p *ngIf="category.description" class="margin-top-medium">{{ category.description }}</p>
      </div>
      <div class="cell cell-large-col-span-8">
        <div *ngFor="let subcategory of category.subcategories; index as k;" class="accordion-item inactive">
          <button class="h4-subheading padding-vertical-medium accordion-header" (click)="toggleActive($event)" [id]="'accordion' + i + k" [attr.aria-controls]="'section' + i + k" aria-expanded="false">
            <span>{{ subcategory.label }}</span>
            <div class="accordion-button"></div>
          </button>
          <div class="accordion-content padding-bottom-medium" [id]="'section' + i + k" role="region" [attr.aria-labelledby]="'accordion' + i + k">
            <p *ngIf="subcategory.description" class="margin-bottom-small">{{ subcategory.description }}</p>
            <div *ngFor="let document of subcategory.documents" class="document-item padding-vertical-medium">
              <a [href]="document?.url" color="primary" target="_blank">
                <mat-icon class="file_download material-icons-outlined download-icon"></mat-icon>
                <span>{{ document?.document_title }}</span>
              </a>
              <p class="text-small" *ngIf="document?.description">{{ document.description }}</p>
            </div>
            <div *ngIf="subcategory.previous_documents && subcategory.previous_documents.length" class="previous-documents padding-vertical-medium padding-horizontal-medium">
              <h4>Previous</h4>
              <div *ngFor="let document of subcategory.previous_documents" class="document-item padding-vertical-medium">
                <a [href]="document?.url" color="primary" target="_blank">
                  <mat-icon class="file_download material-icons-outlined download-icon"></mat-icon>
                  <span>{{ document?.document_title }}</span>
                </a>
                <p class="text-small" *ngIf="document?.description">{{ document.description }}</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  
  
</div>


<ng-template #noData>
  <!-- Spinner if userData is being fetched -->
  <p>No data...</p>
</ng-template>
